import { UBCore } from './ubtracking/ubtracking.ts';
import { VISITOR_TYPE, TYPE } from './ubtracking/ub-constants.ts';

interface State {
  user: {
    id: number;
  };
  restaurant: {
    id: number;
    name: string;
    linkedCity: {
      name: string;
      fullnameLower: string;
    };
  };
  dish: {
    id: number | string;
  };
  // Note: foodTag is deprecated! Please use value instead.
  foodTag: {
    name: string;
  };
  category: {
    id: number | string;
  };
  value?: string;
}

interface TrackingData {
  page: string;
  category?: string;
  action?: string;
  label?: string;
  value?: string | object | null;
  device_category: string;
  user_agent: string;
  status_code: number;
  ubact: string;
  ubcl: string;
  ubses: string;
  ubref: string;
}

// UBMigrate.storageNames({
//     local: 'client_id',
//     session: 'session_id'
// }, {
//     local: UBCore.storagePrefix + 'client_id',
//     session: UBCore.storagePrefix + 'session_id'
// });

UBCore.send = function (trackingData: TrackingData): boolean {
  let { user, restaurant, dish, foodTag, category } = UBCore.state as State;
  let { value } = trackingData;
  const ubtrackingData = new URLSearchParams();

  if (typeof value === 'object' && value !== null) {
    const val = value as Partial<State>;
    if (val.user) {
      user = val.user;
    }
    if (val.restaurant) {
      restaurant = val.restaurant;
    }
    if (val.dish) {
      dish = val.dish;
    }
    if (val.foodTag) {
      foodTag = val.foodTag;
    }
    if (val.category) {
      category = val.category;
    }
    if (val.value) {
      value = val.value;
    } else {
      value = null;
    }
  }

  ubtrackingData.append('ubacc', UBCore.UBUtils.account());
  ubtrackingData.append('ubcl', trackingData.ubcl);
  ubtrackingData.append('ubses', trackingData.ubses);
  ubtrackingData.append('ubact', trackingData.ubact);
  ubtrackingData.append(
    'ubrdata',
    UBCore.UBUtils.formatUbrdata({
      visitor_type: user ? VISITOR_TYPE.MEMBER : VISITOR_TYPE.VISITOR,
      sk_type: TYPE.WEB,
      is_internal: false,
      uid: user?.id ?? null,
      activeAbTests: UBCore.UBUtils.formatActiveAbTests(UBCore.UBUtils.activeAbTests()) ?? null,
      restaurant_id: restaurant?.id ?? null,
      restaurant_name: restaurant?.name ?? null,
      restaurant_city: restaurant?.linkedCity?.name ?? null,
      dish_id: dish?.id ?? null,
      foodtag_name: foodTag?.name ?? null, // Deprecated, please use value instead;
      category_id: category?.id ?? null
    })
  );
  if (trackingData.ubref) ubtrackingData.append('ubref', trackingData.ubref);
  ubtrackingData.append('ubran', UBCore.UBUtils.randomId(5));
  ubtrackingData.append('status_code', trackingData.status_code.toString());
  ubtrackingData.append('device_category', trackingData.device_category);
  if (trackingData.category) ubtrackingData.append('category', trackingData.category);
  if (trackingData.action) ubtrackingData.append('action', trackingData.action);
  if (trackingData.label) ubtrackingData.append('label', trackingData.label);
  if (trackingData.value && typeof trackingData.value !== 'object')
    ubtrackingData.append('value', trackingData.value);
  ubtrackingData.append('page', trackingData.page);

  return navigator.sendBeacon(UBCore.baseURL + '?' + ubtrackingData.toString());
};

UBCore.storagePrefix = '';

export const UBTracking = UBCore.setup({
  state: {
    user: {
      id: undefined
    },
    restaurant: {
      id: undefined,
      name: undefined,
      linkedCity: {
        name: undefined,
        fullnameLower: undefined
      }
    }
  },
  abTestsPrefix: 'sk-AB-'
});
